import {
  createActionTypes,
  createAsyncActionTypes,
} from "@dpdgroupuk/redux-action-creator";

export default createActionTypes("ADDRESS_LOOKUP", {
  SEARCH: createAsyncActionTypes("SEARCH"),
});
